var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M12 16.8h-1.981A7.44 7.44 0 0 0 3.323 21H1.8v-3C1.8 12.237 6.314 7.528 12 7.216V2.4l10.295 9.152a.6.6 0 0 1 0 .896L12 21.6zm1.8.792V15h-3.781a9.24 9.24 0 0 0-6.41 2.585 9 9 0 0 1 8.49-8.571l1.7-.093V6.408L20.09 12z",
    clipRule: "evenodd"
  })));
};
export default SvgShare;